export default [
    {
        path: "/dealerselect",
        name: "dealerSelect",
        meta: {
            requireAuth: true   // 是否需要登陆(false: 需要, true: 不需要) 
        },
        component: resolve => require(['./pages/dealerSelect'],resolve)
    },
    {
        path: "/nopermissins",
        name: "noPermissins",
        meta: {
            requireAuth: true   // 是否需要登陆(false: 需要, true: 不需要) 
        },
        component: resolve => require(['./pages/noPermissins'],resolve)
    }
]